import { render, staticRenderFns } from "./ScholarWorkDetail.vue?vue&type=template&id=1493fa22&scoped=true&"
import script from "./ScholarWorkDetail.vue?vue&type=script&lang=js&"
export * from "./ScholarWorkDetail.vue?vue&type=script&lang=js&"
import style0 from "../assets/v2/css/trans/common.less?vue&type=style&index=0&id=1493fa22&prod&lang=less&scoped=true&"
import style1 from "./ScholarWorkDetail.vue?vue&type=style&index=1&id=1493fa22&prod&lang=less&"
import style2 from "./ScholarWorkDetail.vue?vue&type=style&index=2&id=1493fa22&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1493fa22",
  null
  
)

export default component.exports